import React from 'react'
import PropTypes from 'prop-types'
import { convertMdToHtml } from '..'
import Interweave from 'interweave'
import Section from '../../Section'
import { isEmpty } from 'lodash-es'

const Scope = ({ report: { reportContent } }) => (
  <Section title="Scope">
    {!isEmpty(reportContent.summary.scope?.description) ? (
      <Interweave content={convertMdToHtml.makeHtml(reportContent.summary.scope?.description)} />
    ) : null}
    {!isEmpty(reportContent.summary.scope?.filesIncluded) ? (
      <div>
        <h4>Files Included</h4>

        <Interweave
          content={convertMdToHtml.makeHtml(reportContent.summary.scope?.filesIncluded)}
        />
      </div>
    ) : null}
    {!isEmpty(reportContent.summary.scope?.filesExcluded) ? (
      <div>
        <h4>Files Excluded</h4>

        <Interweave
          content={convertMdToHtml.makeHtml(reportContent.summary.scope?.filesExcluded)}
        />
      </div>
    ) : null}
  </Section>
)

Scope.propTypes = {
  report: PropTypes.object,
}

export default Scope
